module.exports = __webpack_public_path__ + "static/media/IndustryLeader004.f9743c36.png";